import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

import TariffLine from '~/src/components/TariffLine';

export const theme = {
    flexboxgrid: {
        breakpoints: {
            xs: 0,
            sm: 48,
            md: 80,
            lg: 100,
        },
    },
};

export const TariffTitle = styled.h1`
    width: 100%;
    margin: 16px 0;
    margin-top: 48px;
    ${FONTS.H1};
    color: ${COLORS.TextPrimary};
    
    span {
        display:inline-block;
        width: 100%;
        ${FONTS.XXL};
        margin-top: 10px;
    }
    
    @media (max-width: 530px) {
        ${FONTS.H3};
    }
`;

export const STariffLine = styled(TariffLine)`
    padding-left: 0;
    padding-right: 0;
    width: 100%;
`;

export const StyledButton = styled(BaseButton)`
    max-width: 220px;
    margin: 0 auto;
`;
